<div class="textarea">
    <div class="input-micro">
        <mat-form-field appearance="outline">
          <textarea matInput #input maxlength="5000">
            {{speech.text}}
          </textarea>
          <button
              matPrefix
              mat-icon-button>
              <mat-icon>mic</mat-icon>
          </button>
          <span matSuffix>{{ '0 / 5000' }}</span>
          <button
              matSuffix
              mat-icon-button>
              <mat-icon>edit</mat-icon>
          </button>
        </mat-form-field>

        <div class="actions">
            <button mat-stroked-button (click)="startService()">
                Start
            </button>
            <button mat-stroked-button (click)="stopService()">
                Stop
            </button>
            <button mat-stroked-button (click)="load_tanslate()">
                Translate
            </button>
        </div>
    </div>
    <div class="output-micro">
        <mat-form-field appearance="outline">
          <textarea matInput class="result-box">
            {{textFound}}
          </textarea>
        </mat-form-field>
        <div class="actions">
            <button mat-stroked-button (click)="play()">
                Play
            </button>
        </div>
    </div>
</div>